<template>
    <label
        :class="{
            'toggle-switch-box flex items-center': true,
            'cursor-pointer': !disabled,
            disabled: disabled
        }"
        aria-label="Toggle switch"
    >
        <div
            :style="`height: ${height}px; border: ${borderWeight}px solid; border-radius: ${borderRadius}px; border-color: ${
                checked && borderCheckedActive ? checkedColor : borderColor
            }; background-color: ${checked && showBackground ? color : 'transparent'}`"
            class="toggle-switch relative"
        >
            <div
                :class="[{ 'switch-thumb absolute': true, on: checked }]"
                :style="`background-color: ${checked ? checkedColor : color}`"
            ></div>
            <template v-if="showToggleSymbol">
                <i
                    :style="`font-size: ${height - 8}px; color: ${checkedColor}; opacity: ${checked ? 1 : 0}`"
                    class="checked-label fas fa-check shadow-text-none absolute"
                ></i>
                <i
                    :style="`font-size: ${height - 8}px; color: ${color}; opacity: ${!checked ? 1 : 0}`"
                    class="unchecked-label fas fa-times shadow-text-none absolute"
                ></i>
            </template>
            <input @input="input" type="checkbox" :checked="checked" hidden />
        </div>
        <span id="label-toggle-question-status" v-if="content" v-html="content"></span>
    </label>
</template>

<script>
export default {
    name: 'XToggleSwitch',

    props: {
        checked: {
            type: [String, Boolean],
            default: false
        },

        disabled: {
            type: [String, Boolean],
            default: false
        },

        content: {
            type: [String, Boolean],
            default: false
        },

        height: {
            type: [String, Number],
            default: 16
        },

        color: {
            type: String,
            default: '#fff'
        },

        checkedColor: {
            type: String,
            default: '#fff'
        },

        borderWeight: {
            type: [String, Number],
            default: 1
        },

        borderRadius: {
            type: [String, Number],
            default: 16
        },

        borderColor: {
            type: String,
            default: 'transparent'
        },

        borderCheckedActive: {
            type: [String, Boolean],
            default: false
        },

        showToggleSymbol: {
            type: [String, Boolean],
            default: false
        },

        showBackground: {
            type: [String, Boolean],
            default: false
        }
    },

    methods: {
        input(e) {
            this.$emit('input', e)
        }
    }
}
</script>

<style lang="scss">
.toggle-switch-box {
    column-gap: 8px;
    transition: opacity 0.3s ease, background-color 0.3s ease;

    &.disabled {
        opacity: 0.5;
        pointer-events: none;
    }

    .toggle-switch {
        aspect-ratio: 2 / 1;
        border: 1px solid;
        transition: background-color 0.3s ease, border-color 0.3s ease;

        .switch-thumb {
            top: 50%;
            left: 6%;
            transform: translate3d(0, -50%, 0);
            height: 82%;
            border-radius: 50%;
            aspect-ratio: 1 / 1;
            transition: left 0.3s ease, background-color 0.3s ease;

            &.on {
                left: calc(100% - 42%);
            }
        }

        .checked-label {
            top: 50%;
            left: 20%;
            transform: translate3d(0, -50%, 0);
            transition: opacity 0.3s;
        }

        .unchecked-label {
            top: 50%;
            right: 20%;
            transform: translate3d(0, -50%, 0);
            transition: opacity 0.3s;
        }
    }
}
</style>